export const SaleSymbols = {
    SaleService: Symbol.for("SaleService"),
    SaleProvider: Symbol.for("SaleProvider")
}